import React, { ChangeEvent, FunctionComponent, useState } from "react";
import { useTheme } from "@mui/material/styles";
import stylesDefault from "../SiteManagement/styles"; //TODO export these further up!
import Header from "../Header/Header";
import authService from "../../services/AuthService";
import { SUBPAGES } from "./constants";
import SSOProviderList from "./Providers/SSOProviderList";
import SSOProviderSiteList from "./Sites/SSOProviderSiteList";
import LTIPlatformList from "./LTIPlatforms/LTIPlatformList";
import SSOProviderSiteActions from "./Sites/SSOProviderSiteActions";
import LTIPlatformActions from "./LTIPlatforms/LTIPlatformActions";
import SSOProviderActions from "./Providers/SSOProviderActions";
import {
  LTIPlatformDTO,
  ProviderSiteDTO,
  SSOProviderDTO,
} from "@beable/roster-backend-client-v1";
import { Grid, Typography, Container } from "@mui/material";
import BasePanel from "../Common/Layout/BasePanel";
import { BasePanelBox } from "../Common/Layout/BasePanelBox";
import BaseSheet from "../Common/Layout/BaseSheet";
import { StyledPanelHeader } from "../Common/Layout/PanelHeader";
import SSOToggleAndSearch from "./SSOToggleAndSearch";

export default function SSOManagement() {
  const theme = useTheme();
  const styles = stylesDefault.pageStyles(theme);

  const profile = authService.getUser();
  const [subpage, setSubpage] = useState(SUBPAGES.providers.value);
  const [selectedItem, setSelectedItem] = useState<
    LTIPlatformDTO | SSOProviderDTO | ProviderSiteDTO | undefined
  >();
  const [searchTerm, setSearchTerm] = useState("");
  const [action, setAction] = useState<"refresh" | "search" | undefined>();
  const handleSubpageChange = (
    _event: ChangeEvent<HTMLInputElement>,
    newPage: string
  ) => {
    setSubpage(newPage);
    setSearchTerm('');
    setSelectedItem(undefined);
  };

  const actionComplete = (success: boolean) => {
    if (success) {
      setAction("refresh");
      if (searchTerm !== "") {
        setSearchTerm("");
      }
      setTimeout(() => setAction(undefined), 2000);
    }
    setSelectedItem(SUBPAGES[subpage].defaultState);
  };

  const handleSearch = (searchTerm: string) => {
    setSearchTerm(searchTerm);
    setAction("search");
  };

  const handleSelectItem = (item: LTIPlatformDTO | SSOProviderDTO | ProviderSiteDTO) => {
    setSelectedItem(item);
    setAction(undefined);
  }

  const displayList = () => {
    const { component, castItem } = (() => {
      switch (subpage) {
        case SUBPAGES.providers.value:
          return {
            component: SSOProviderList,
            castItem: selectedItem as SSOProviderDTO,
          };
        case SUBPAGES.providerSites.value:
          return {
            component: SSOProviderSiteList,
            castItem: selectedItem as ProviderSiteDTO,
          };
        default:
          return {
            component: LTIPlatformList,
            castItem: selectedItem as LTIPlatformDTO,
          };
      }
    })();

    const ListComponent: FunctionComponent<any> = component;

    return (
      <ListComponent
        action={action}
        selectedItem={castItem}
        setSelectedItem={handleSelectItem}
        searchTerm={searchTerm}
      />
    );
  };

  const displayActions = () => {
    const { component, castItem } = (() => {
      switch (subpage) {
        case SUBPAGES.providers.value:
          return {
            component: SSOProviderActions,
            castItem: selectedItem as SSOProviderDTO,
          };
        case SUBPAGES.providerSites.value:
          return {
            component: SSOProviderSiteActions,
            castItem: selectedItem as ProviderSiteDTO,
          };
        default:
          return {
            component: LTIPlatformActions,
            castItem: selectedItem as LTIPlatformDTO,
          };
      }
    })();

    const ActionComponent: FunctionComponent<any> = component;

    return (
      <ActionComponent
        selectedItem={castItem}
        onActionComplete={actionComplete}
      />
    );
  };

  return (
    <>
      <Header />
      <Grid container sx={{ position: 'relative', width: '100%', minHeight: '100%' }}>
        <BasePanel>
          <BasePanelBox>
            <StyledPanelHeader header="SSO Management" />
            <Grid container size={12}>
              <Typography variant="h5" sx={{ margin: "16px" }}>
                General Options
              </Typography>
              {displayActions()}
            </Grid>
          </BasePanelBox>
        </BasePanel>
        <BaseSheet maxWidth="lg">
          <Grid size={12}>
            <Typography align-left="true" sx={{
              marginBottom: "16px"
            }}>
              Use this page to manage SSO providers and sites within the Beable
              system.
            </Typography>
            <Container sx={styles.dfb}>
              <SSOToggleAndSearch
                activePage={subpage}
                onPageChange={handleSubpageChange}
                handleSearch={handleSearch}
                clearSearch={searchTerm === ''}
              />
            </Container>
            {profile ? displayList() : undefined}
          </Grid>
        </BaseSheet>
      </Grid>
    </>
  );
}
